import { Directive, Renderer2, ElementRef, OnInit } from '@angular/core';
import { DeviceFormatHelperService } from '../services/device-format-helper.service';

@Directive({
    selector: '[appChangeFormat]'
})
export class ChangeFormatDirective implements OnInit {
    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
        private deviceFormatHelper: DeviceFormatHelperService) {
    }

    ngOnInit() {
        this.setFormat();
    }

    setFormat() {
        // console.log('set Format', window.innerWidth, window.innerWidth < this.deviceFormatHelper.SIZE_MOBILE_WITDH);
        if (window.innerWidth < this.deviceFormatHelper.SIZE_MOBILE_WITDH) {
            this.renderer.addClass(document.body, this.deviceFormatHelper.mobileFormatClassName);
        } else {
            this.renderer.addClass(document.body, this.deviceFormatHelper.desktopFormatClassName);
        }
    }
}
